import { useWindowSize } from 'react-use'

export const useScreenSizes = () => {
  const { width } = useWindowSize()

  const isTabletDisplayOrLower = width <= 1024
  const isMobileDisplay = width <= 600
  const isLaptop = width > 1024 && width < 1200
  return {
    isTabletDisplayOrLower,
    isMobileDisplay,
    isLaptop
  }
}
